exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lm-new-row{width:880px;height:50px;cursor:pointer;border:1px dashed #000}", ""]);

// exports
